module.exports = "<router-outlet  >\n  <mat-progress-bar class=\"loadingbar\" *ngIf=\"showLoader\" mode=\"indeterminate\" color=\"accent\"> </mat-progress-bar>\n</router-outlet>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main